import logger from 'Utils/Logger';

export const debugReducer = (
  state: Record<string, unknown> = {},
  action: { type: string; [key: string]: unknown },
) => {
  // The type only: an action's payload can be a password or a user record.
  logger.debug(action.type);
  return state;
};
